// Perfiles ILUSTRATIVOS (nombres y fotos ficticios). No son testimonios ni resultados reales:
// sin estrellas, sin sello de verificado y sin promesas de ingresos.
// Cuando haya testimonios reales con autorización por escrito, reemplázalos aquí.
export type Profile = { photo: string; name: string; place: string; title: string; body: string };

export const PROFILES: Profile[] = [
  {
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/6f2cee98-b04e-4273-bbf8-d91042fb033a.jpg',
    name: 'Daniela M.',
    place: 'Houston, TX',
    title: 'Quiero algo propio sin dejar mi trabajo',
    body: 'Trabajo en atención al cliente y se me da bien hablar con la gente. Busco aprender a vender y construir algo a mi ritmo, en las tardes y los fines de semana.',
  },
  {
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/1f10f8f0-1a2a-49de-b377-85a579a5ec91.jpg',
    name: 'Carlos R.',
    place: 'Orlando, FL',
    title: 'Me interesa ayudar a familias como la mía',
    body: 'Cuando llegamos a EE.UU. nadie nos explicó cómo proteger a nuestra familia. Quiero capacitarme, sacar mi licencia y ser esa persona para otros.',
  },
  {
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/2a2946c2-b454-48b0-8a5a-27f1310bd446.jpg',
    name: 'Patricia G.',
    place: 'Miami, FL',
    title: 'Busco más libertad con mi horario',
    body: 'Tengo experiencia en ventas, pero quiero algo que dependa de mí. Antes de decidir, quiero conocer con claridad los costos y los requisitos.',
  },
  {
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/791a5c16-7772-429f-907f-7c3dbbeeea8a.jpg',
    name: 'José L.',
    place: 'Dallas, TX',
    title: 'Quiero dejar de empezar desde cero',
    body: 'Ya probé otros negocios donde me tocaba buscar clientes solo. Lo que me interesa es entrar a un equipo con sistema y prospectos.',
  },
  {
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/bda20e16-1401-48cb-826c-5d45fdcad101.jpg',
    name: 'Valeria S.',
    place: 'Los Ángeles, CA',
    title: 'Quiero aprender una habilidad que me sirva siempre',
    body: 'Soy joven y no tengo experiencia en ventas. Quiero capacitarme bien desde el principio y crecer con un equipo que me acompañe.',
  },
  {
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/6732e9a2-d8ce-456d-9f51-53d09be52e9f.jpg',
    name: 'Miguel A.',
    place: 'Atlanta, GA',
    title: 'Me veo formando mi propio equipo',
    body: 'Me gusta liderar y conectar con personas. Quiero entender cómo se construye un equipo paso a paso y qué se necesita para llegar ahí.',
  },
  {
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/3d4bb187-b8c9-47e0-9d04-ef9d45b3f8ef.jpg',
    name: 'Rosa E.',
    place: 'Newark, NJ',
    title: 'Nunca es tarde para algo nuevo',
    body: 'Mis hijos ya están grandes y tengo tiempo. Quiero aprender sobre protección financiera y ayudar a mi comunidad a planear mejor.',
  },
];
